import React from "react";
import HubTabs from "../../components/HubTabs";
import FlowBuilder from "../FlowBuilder";
import CampaignsPhrase from "../CampaignsPhrase";
import { i18n } from "../../translate/i18n";

const tLang = (key, fallback) => {
  const v = i18n.t(key);
  return !v || v === key ? fallback : v;
};

const tabs = [
  {
    label: tLang("flowbuilder.subMenus.conversation", "Conversa"),
    path: "/flowbuilders",
    Component: FlowBuilder,
  },
  {
    label: tLang("flowbuilder.subMenus.campaign", "Campanha"),
    path: "/phrase-lists",
    Component: CampaignsPhrase,
  },
];

const FlowHub = () => <HubTabs tabs={tabs} />;

export default FlowHub;
